"use strict";

exports.__esModule = true;
exports.FormRepeat = void 0;

var _utils = require("@bydesign-ui/utils");

var _nestWatcher = require("../../../models/nest-watcher");

var _util = require("../util");

var _FormGroup2 = require("./FormGroup");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var FormRepeat = function (_FormGroup) {
  _inheritsLoose(FormRepeat, _FormGroup);

  function FormRepeat(form, scope, options) {
    var _this;

    _this = _FormGroup.call(this, form, scope, {
      field: options.field,
      defaultValue: options.defaultValue || []
    }) || this;
    _this.parts = {};
    _this.partGroups = {};
    _this.partKeys = [];
    _this.itemInitValue = options.itemInitValue;

    _this.initRepeat();

    return _this;
  }

  var _proto = FormRepeat.prototype;

  _proto.reset = function reset() {
    this.cleanRepeatItems();
  };

  _proto.isRepeat = function isRepeat() {
    return true;
  };

  _proto.getRepeatGroup = function getRepeatGroup(key) {
    return this.partGroups[key];
  };

  _proto.appendRepeatItem = function appendRepeatItem(data) {
    var path = this.getPath();
    var value = this.form.getPathValue(path);
    var pathValue = value.concat(data == null ? this.getItemInitValue() : data);
    this.form.setPathValue(path, pathValue);
  };

  _proto.insertBeforeRepeatItem = function insertBeforeRepeatItem(key, data) {
    var path = this.getPath();
    var value = this.form.getPathValue(path);
    var index = Math.max(this.node.getIndex(this.parts[key]), 0);
    var list = value.slice(0);
    list.splice(index, 0, data == null ? this.getItemInitValue() : data);
    this.form.setPathValue(path, list);
  };

  _proto.insertAfterRepeatItem = function insertAfterRepeatItem(key, data) {
    var path = this.getPath();
    var value = this.form.getPathValue(path);
    var index = Math.max(this.node.getIndex(this.parts[key]) + 1, value.length);
    var list = value.slice(0);
    list.splice(index, 0, data == null ? this.getItemInitValue() : data);
    this.form.setPathValue(path, list);
  };

  _proto.insertRepeatItem = function insertRepeatItem(key, data) {
    var path = this.getPath();
    var value = this.form.getPathValue(path);
    var list = value.slice(0);
    var index = this.node.getIndex(this.parts[key]);
    list.splice(index, 0, data == null ? this.getItemInitValue() : data);
    this.form.setPathValue(path, list);
  };

  _proto.removeRepeatItem = function removeRepeatItem(key) {
    var path = this.getPath();
    var value = this.form.getPathValue(path);
    var list = value.slice(0);
    var index = this.node.getIndex(this.parts[key]);
    list.splice(index, 1);
    this.form.setPathValue(path, list, false, {
      removeRepeat: true
    });
  };

  _proto.cleanRepeatItems = function cleanRepeatItems() {
    var path = this.getPath();
    this.form.setPathValue(path, []);
  };

  _proto.sortRepeatItem = function sortRepeatItem(fromKey, toKey) {
    var path = this.getPath();
    var value = this.form.getPathValue(path);
    var list = value.slice(0);
    var from = this.node.getIndex(this.parts[fromKey]);
    var to = this.node.getIndex(this.parts[toKey]);

    if (from === to) {
      return;
    }

    if (from < to) {
      to--;
    }

    list.splice.apply(list, [to, 0].concat(list.splice(from, 1)));
    this.form.setPathValue(path, list);
  };

  _proto.getRepeatInfo = function getRepeatInfo() {
    var group = this.getGroupInfo();
    return _extends({}, group, {
      keys: this.partKeys,
      datasource: this.form.getPathValue(this.getPath())
    });
  };

  _proto.initRepeat = function initRepeat() {
    var _this2 = this;

    var path = this.getPath();
    this.form.absoluteWatch(this.id, [_nestWatcher.NestWatcher.combineKeys((0, _util.getNestWatchPath)(this.node))], function (pathArr, flags) {
      var removeRepeat = Boolean(flags.removeRepeat);

      if (removeRepeat) {
        var check = Boolean(pathArr.length === 1 && pathArr[0] === 'model.' + path);
        if (check) _this2.updateBrickParts();
      } else {
        _this2.updateBrickParts();
      }
    });
    this.updateBrickParts(true);
  };

  _proto.updateBrickParts = function updateBrickParts(isSilent) {
    var _this3 = this;

    if (isSilent === void 0) {
      isSilent = false;
    }

    var newPartList = this.getPartList();
    Object.keys(this.parts).forEach(function (key) {
      if (!newPartList.includes(key)) {
        _this3.parts[key].remove();

        _this3.partGroups[key].dispose();
      }
    });
    var container = this.node;
    var oldList = container.getChildNodes();
    var newElemList = newPartList.map(function (part) {
      return _this3.parts[part] || _this3.createPartNode(part);
    });
    oldList.forEach(function (item) {
      return item.remove();
    });
    newElemList.forEach(function (elem) {
      return container.appendChild(elem);
    });

    if (!isSilent) {
      this.emit('repaint');
    }
  };

  _proto.getPartList = function getPartList() {
    var value = this.form.getPathValue(this.getPath());

    if (!Array.isArray(value)) {
      return [];
    }

    return this.partKeys = value.map(function (item) {
      return (0, _utils.getUniqueKey)(item);
    });
  };

  _proto.createPartNode = function createPartNode(part) {
    var group = this.partGroups[part] = new _FormGroup2.FormGroup(this.form, this.node, {
      field: part,
      defaultValue: this.itemInitValue,
      repeat: true
    });
    return this.parts[part] = group.getNode();
  };

  _proto.getItemInitValue = function getItemInitValue() {
    var fn = this.itemInitValue;
    return typeof fn === 'function' ? fn() : (0, _utils.deepClone)(fn);
  };

  return FormRepeat;
}(_FormGroup2.FormGroup);

exports.FormRepeat = FormRepeat;